import CrudCustom from '../../../libs/custom/CrudCustom';

let TarifProgresifPasal17Service = new CrudCustom('/tarif-progresif-pasal17s');
export default TarifProgresifPasal17Service;
